module.exports = __webpack_public_path__ + "img/03.5096d7b7.jpg";